import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { VolumesSection } from './components/VolumesSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="w-full bg-charcoal-950 font-sans text-body" data-id="element-0" data-mp="23u9tmmkgrbwr">
      <Hero data-id="element-1" data-mp="3ijxsgzk2wgo4" />

      <main data-id="element-2" data-mp="3ikha0f5th31m">
        <TestimonialsSection data-id="element-3" data-mp="3ikqwhsrnks2k" />
        <PainSection data-id="element-4" data-mp="3ijpbavgxap74" />
        <SystemRevealSection data-id="element-5" data-mp="3ii4r9zs8ioni" />
        <VolumesSection data-id="element-6" data-mp="3ml1234bj9ggw" />
        <IncludesSection data-id="element-7" data-mp="3mk852v2dm5by" />
        <BonusesSection data-id="element-8" data-mp="3mjgannkimdn9" />
        <OfferSection data-id="element-9" data-mp="3rc9i4j7dc031" />
        <TestimonialsSection variant="compact" id="proof-2" data-id="element-10" data-mp="3rbzomln47asl" />
        <GuaranteeSection data-id="element-11" data-mp="3relvsk63foaa" />
        <FaqSection data-id="element-12" data-mp="6hq1ea16ddl" />
        <CostSection data-id="element-13" data-mp="4wylxj0jajy" />
        <FinalOfferSection data-id="element-14" data-mp="56n1goet9nj" />
      </main>

      <Footer data-id="element-15" data-mp="2zld259q0hfbj" />
      <StickyCta data-id="element-16" data-mp="2zlv6yuqqp1v2" />
      <PurchaseToast data-id="element-17" data-mp="2zmeoiach9o8k" />
    </div>;
}